<template>
  <div>
    <b-container>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
          <b-card>
            <template #header>
              <h6 class="mb-0">Declaraciones y autorización de datos</h6>
            </template>

            <div class="declaracion-texto mb-3">
              <p class="font-weight-bold mb-2">Declaro expresamente:</p>

              <p class="mb-2">
                <strong>I.</strong> Que para efectos de acceder a la prestación de servicios por parte de
                LA ASEGURADORA Y/O EL INTERMEDIARIO DE SEGUROS, suministro mis datos personales para todos
                los fines precontractuales y contractuales que comprende la actividad aseguradora.
              </p>

              <p class="mb-2">
                <strong>II.</strong> Que LA ASEGURADORA Y/O EL INTERMEDIARIO DE SEGUROS me ha informado,
                de manera expresa:
              </p>

              <p class="mb-2">
                <strong>1. FINALIDAD DEL TRATAMIENTO DE DATOS PERSONALES:</strong> Que mis datos personales
                serán tratados por LA ASEGURADORA Y/O EL INTERMEDIARIO DE SEGUROS, para las siguientes
                finalidades: i) el trámite de mi solicitud de vinculación como consumidor financiero, deudor,
                contraparte contractual y/o proveedor, ii) el proceso de negociación de contratos con LA
                ASEGURADORA, incluyendo la determinación de primas y la selección de riesgos, iii) la
                ejecución y el cumplimiento de los contratos que celebre, iv) el control y la prevención del
                fraude, v) la liquidación y pago de siniestros, vi) todo lo que involucre la gestión integral
                del seguro contratado, vii) controlar el cumplimiento de requisitos para acceder al Sistema
                General de Seguridad Social Integral, viii) la elaboración de estudios técnico-actuariales,
                estadísticas, encuestas, análisis de tendencias del mercado y en general, estudios de técnica
                aseguradora, ix) envío de información relativa a la educación financiera, encuestas de
                satisfacción de clientes, y ofertas comerciales de seguros, así como de otros servicios
                inherentes a la actividad aseguradora, x) Realización de encuestas sobre satisfacción en los
                servicios prestados por LA ASEGURADORA Y/O EL INTERMEDIARIO DE SEGUROS, xi) intercambio o
                remisión de información en virtud de tratados y acuerdos internacionales e intergubernamentales
                suscritos por Colombia, xii) la prevención y control del lavado de activos y la financiación
                del terrorismo, xiii) Consulta, almacenamiento, administración, transferencia, procesamiento y
                reporte de información a las Centrales de Información o bases de datos debidamente constituidas
                referentes al comportamiento crediticio, financiero y comercial.
              </p>

              <p class="mb-2">
                <strong>2.</strong> El Tratamiento podrá ser realizado directamente por dichas empresas o por
                los encargados del tratamiento que ellas consideren necesarios.
              </p>

              <p class="mb-2">
                <strong>3. USUARIOS DE LA INFORMACIÓN:</strong> i) personas jurídicas que tienen la calidad de
                filiales, subsidiarias, o vinculadas o de matriz de LA ASEGURADORA Y/O EL INTERMEDIARIO DE
                SEGUROS, ii) los operadores necesarios para el cumplimiento de derechos y obligaciones
                derivados de los contratos celebrados con LA ASEGURADORA Y/O EL INTERMEDIARIO DE SEGUROS,
                tales como: ajustadores, call centers, investigadores, compañías de asistencia, abogados
                externos, entre otros; iii) los intermediarios de seguros que intervengan en el proceso de
                celebración, ejecución y terminación del contrato de seguro; iv) las personas con las cuales
                LA ASEGURADORA Y/O EL INTERMEDIARIO DE SEGUROS adelante gestiones para efectos de celebrar
                contratos de coaseguros o reaseguro; v) FASECOLDA, INVERFAS S.A. y el INIF, personas jurídicas
                que administran bases de datos para efectos de prevención y control de fraudes, la selección
                de riesgos y control de requisitos para acceder al Sistema General de Seguridad Social
                Integral, así como la elaboración de estudios estadísticos actuariales.
              </p>

              <p class="mb-2">
                <strong>4. TRANSFERENCIA INTERNACIONAL DE INFORMACIÓN A TERCEROS PAÍSES:</strong> Que en
                ciertas situaciones es necesario realizar transferencias internacionales de mis datos para
                cumplir las finalidades del tratamiento.
              </p>

              <p class="mb-2">
                <strong>5. DATOS SENSIBLES:</strong> Que son facultativas las respuestas a las preguntas que
                me han hecho o me harán sobre datos personales sensibles, de conformidad con la definición
                legal vigente. En consecuencia, no he sido obligado a responderlas, por lo que autorizo
                expresamente para que se lleve a cabo el tratamiento de mis datos sensibles, en especial, los
                relativos a la salud y a los datos biométricos. En todo caso, para efectos del presente
                formulario de conocimiento del cliente se debe tener en consideración que el capítulo XI del
                Título I de la Circular Básica Jurídica de la Superintendencia Financiera de Colombia exige
                las mismas.
              </p>

              <p class="mb-2">
                <strong>6. TRANSFERENCIA INTERNACIONAL DE INFORMACIÓN A TERCEROS PAÍSES:</strong> Que en
                ciertas situaciones es necesario realizar transferencias internacionales de mis datos para
                cumplir las finalidades del tratamiento.
              </p>

              <p class="mb-2">
                <strong>7. DERECHOS DEL TITULAR DE LA INFORMACIÓN:</strong> Que como titular de la
                información, me asisten los derechos previstos en las leyes 1266 de 2008 y 1581 de 2012. En
                especial, me asiste el derecho a conocer, actualizar y rectificar las informaciones que se
                hayan recogido sobre mí.
              </p>

              <p class="mb-2">
                <strong>8. RESPONSABLES Y ENCARGADOS DEL TRATAMIENTO DE LA INFORMACIÓN:</strong> Que los
                responsables del tratamiento de la información son LAS ASEGURADORAS Y/O LOS INTERMEDIARIOS
                DE SEGUROS, cuyos datos de contacto se incluyeron en el encabezado de esta autorización. En
                todo caso, los encargados del tratamiento de los datos que se compartan, transfieran,
                transmitan, entreguen o divulguen, en desarrollo de lo previsto en el literal v) del numeral
                3 anterior, serán: a) FASECOLDA cuya dirección es Carrera 7 No. 26-20 Pisos 11 y 12, email:
                fasecolda@fasecolda.com Tel. 3443080 de la ciudad de Bogotá. b) INVERFAS cuya dirección es
                Carrera 7 No. 26-20 Piso 11, email: inverfas@fasecolda.com Tel. 3443080 de la ciudad de
                Bogotá. c) INIF - Instituto Nacional de Investigación y Prevención del Fraude al Seguro cuya
                dirección es Carrera 13 No. 37-43 Piso 8, email: directoroperativo@inif.com.co Tel. 2320105 de
                la ciudad de Bogotá.
              </p>

              <p class="mb-2 mt-3">
                <strong>III. AUTORIZACIÓN:</strong> De manera expresa, autorizo el tratamiento de los datos
                personales, incluidos los sensibles y autorizo, de ser necesario, la transferencia
                internacional de los mismos, por las personas, para las finalidades y en los términos que me
                fueron informados en este documento.
              </p>
            </div>

            <b-form-group class="mt-4 mb-0">
              <b-form-checkbox v-model="form.declaracionesAceptadas" name="declaracionesAceptadas">
                Declaro que he leído, entendido y acepto en su totalidad las declaraciones y autorizaciones anteriores.
              </b-form-checkbox>
            </b-form-group>

            <b-row align-h="end" class="mt-4">
              <b-col cols="12" md="4" class="d-flex justify-content-end">
                <b-button @click="previous" variant="secondary" class="mr-2">Anterior</b-button>
                <b-button type="submit" variant="primary" :disabled="!form.declaracionesAceptadas">Firmar</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "FormColombiaSalud06",
  data() {
    return { form: {} };
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const { form } = this.$store.state.wizard;
    if (form === undefined || form === null || form === "") {
      this.$router.push("/form/colombia/salud/");
      return;
    }
    this.form = { ...form, declaracionesAceptadas: form.declaracionesAceptadas || false };
    this.$store.dispatch("app/loading", false);
  },
  methods: {
    previous() {
      this.$store
        .dispatch("wizard/save", { index: 5, form: this.form })
        .then(() => this.$router.push("/form/colombia-salud-5.html"));
    },
    next() {
      if (!this.form.declaracionesAceptadas) return;
      this.$store
        .dispatch("wizard/save", { index: 6, form: this.form })
        .then(() => this.$router.push("/form/colombia-salud-7.html"));
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1600px;
}
.declaracion-texto {
  max-height: 420px;
  overflow-y: auto;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  font-size: 0.9rem;
  line-height: 1.45;
}
.declaracion-texto p {
  margin-bottom: 0.75rem;
  text-align: justify;
}
</style>
